var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;opacity:0.198;}.b{fill:#bcbcbc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-409.945 -771.568)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(409.945 771.568)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11,1H0V-1H11Z",
    transform: "translate(416.446 783.568)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNg);
export default __webpack_public_path__ + "static/media/icon_NG.38307b0d982a246935d2335272fb0c02.svg";
export { ForwardRef as ReactComponent };